<template>
  <LayoutDataset>
    <template v-slot:breadcrumbs>
      <Breadcrumbs :links="breadcrumbs" />
    </template>
    <div v-if="!!swaggerObject">
      <div class="dataset-detail">
        <div>
          <h1>{{ swaggerObject.summary }}</h1>
          <p>{{ swaggerObject.description }}</p>
          <div class="tabs-nav">
            <el-radio-group
              v-model="tabActive"
              class="el-radio-group--custom-mobile"
            >
              <el-radio-button label="data">{{
                $t("pages.datasetDetail.tabs.data")
              }}</el-radio-button>
              <el-radio-button label="api">{{
                $t("pages.datasetDetail.tabs.api")
              }}</el-radio-button>
            </el-radio-group>
          </div>

          <MobileSeparator />

          <div class="tabs-content">
            <TabData
              :swaggerObject="swaggerObject"
              v-if="tabActive === 'data'"
            />
            <TabApi :swaggerObject="swaggerObject" v-if="tabActive === 'api'" />
          </div>
        </div>
      </div>
    </div>
  </LayoutDataset>
</template>

<script>
import { swaggerUrl } from "@/mixins";
import SwaggerObject from "@/helpers/SwarggerObject";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import TabData from "./detail/Data";
import TabApi from "./detail/Api";

export default {
  mixins: [swaggerUrl],
  components: {
    Breadcrumbs,
    TabData,
    TabApi
  },
  props: {
    dataset: String
  },
  data: function() {
    return {
      tabActive: "data",
      swaggerObject: null
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          name: "datasets",
          link: "datasets"
        },
        {
          name: "dataset-detail",
          link: null,
          value: this.swaggerObject ? this.swaggerObject.summary : ""
        }
      ];
    }
  },
  methods: {
    handleTab(tabName) {
      this.tabActive = tabName;
    },
    tabDisabled(name) {
      return name === this.tabActive;
    }
  },
  mounted() {
    const swagger = new SwaggerObject();

    swagger
      .init(this.swaggerUrl(), this.dataset)
      .then(() => {
        this.swaggerObject = swagger;
      })
      .catch(() => {
        this.$message({
          type: "error",
          message: this.$t("common.flashMessages.somethingWentWrong")
        });
      });
  }
};
</script>

<style lang="scss" scoped>
h1 {
  margin: 0 0 em(20, 32);
  font-size: rem(32);
  text-align: left;
  @include media("<navbar-sm") {
    margin-bottom: em(10, 20);
    font-size: rem(20);
    color: $--text-primary;
  }
}

.tabs-nav {
  margin: rem(45) 0 rem(50);
  text-align: right;
  @include media("<navbar-sm") {
    margin-bottom: 0;
    min-width: 120px;
    text-align: left;
  }
}

.tabs-content {
  @include media("<navbar-sm") {
    margin-top: rem(30);
  }
}
</style>
